'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

exports.getCookieValue = getCookieValue;
exports.getUserDetails = getUserDetails;
exports.lazyLoadScript = lazyLoadScript;
exports.isWixOrigin = isWixOrigin;
exports.boolToPromise = boolToPromise;
exports.invertPromise = invertPromise;
exports.somePromise = somePromise;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getCookieValue(name) {
  return (document.cookie.match(name + '=([^;]*)') || ['']).pop();
}

function getUserDetails(options) {
  var wixClient = getCookieValue('wixClient').split('|');
  var userId = wixClient[6] || getCookieValue('_wixCIDX');
  var userDetails = { label_str: options.label, labels_str: options.label };
  if (wixClient[0]) {
    userDetails.displayName = wixClient[0];
    try {
      userDetails.email = JSON.parse(localStorage['userID-' + userId]).details.email;
    } catch (e) {}
  } else {
    userDetails.prevUserId_str = getCookieValue('_wixUIDX').split('|').pop();
  }
  return { userDetails: userDetails, userId: userId };
}

function lazyLoadScript(src, id, callback, attributes) {
  if (!document.getElementById(id)) {
    var fjs = document.getElementsByTagName('script')[0];
    var js = document.createElement('script');
    js.id = id;
    js.src = src;
    if (callback) {
      js.addEventListener('load', callback);
    }

    if (attributes) {
      (0, _keys2.default)(attributes).forEach(function (attributeName) {
        js.setAttribute(attributeName, attributes[attributeName]);
      });
    }
    fjs.parentNode.insertBefore(js, fjs);
  }
}

function isWixOrigin() {
  return window.location.host.indexOf('wix.com') !== -1;
}

function boolToPromise(bool) {
  return _promise2.default.resolve(bool).then(function (bool) {
    return bool ? _promise2.default.resolve(bool) : _promise2.default.reject(bool);
  });
}

function invertPromise(p) {
  return new _promise2.default(function (resolve, reject) {
    return _promise2.default.resolve(p).then(reject).catch(resolve);
  });
}

function somePromise(arr) {
  return invertPromise(_promise2.default.all(arr.map(invertPromise)));
}